// Copyright (c) Move Closer 2022.

import { QueryRegistry } from '@core'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export const appQueries: QueryRegistry = {
  // Here goes a global app Queries.
  //
}
